import React from 'react';
import { SectionLabel } from '../SectionLabel';
import { CtaButton } from '../CtaButton';
const AUTHOR_PHOTO = 'https://cdn.magicpatterns.com/patterns/generated-images/b4a775bf-030f-44d5-a95c-120bf10b9e4b.jpg';
const credentials = ['18 anni di officina, dalle lavatrici ai frigoriferi no-frost', 'Oltre 11.000 interventi gestiti con gli stessi processi che troverai dentro', 'Formatore di più di 2.000 tecnici indipendenti'];
export function Author() {
  return <section className="border-b border-white/10 bg-ink-950" data-id="element-67" data-mp="20iabt2htv1rc">
      <div className="mx-auto w-full max-w-xl px-4 py-12 sm:py-16 lg:max-w-5xl" data-id="element-68" data-mp="20hqxdvrdyvi2">
        <div className="lg:grid lg:grid-cols-[0.85fr_1.15fr] lg:items-center lg:gap-12" data-id="element-69" data-mp="2fe858d0d9rzv">
          <figure className="mx-auto w-full max-w-[280px] lg:max-w-none" data-id="element-70" data-mp="2ahhp5pokaweg">
            <img src={AUTHOR_PHOTO} alt="Marco Ferrero, tecnico specializzato in elettrodomestici, nel suo laboratorio" className="w-full rounded-2xl border border-white/10 object-cover" width={800} height={1000} data-id="element-71" data-mp="l18m49ws2fnu" />
          </figure>

          <div className="mt-7 lg:mt-0" data-id="element-72" data-mp="3kf6f2lhz23zr">
            <SectionLabel data-id="element-73" data-mp="3kg7s2vijt0k4">Chi ha creato il sistema</SectionLabel>
            <h2 className="mt-4 font-display text-[26px] uppercase leading-[1.1] text-white sm:text-3xl lg:text-[38px]" data-id="element-74" data-mp="3pdzqm8dp7kxa">
              Marco Ferrero, <span className="text-accent" data-id="element-75" data-mp="3u7u7z55tznt7">tecnico di elettrodomestici</span>
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-white/65 sm:text-base" data-id="element-76" data-mp="2z6okur5iaoa">
              Ho iniziato riparando lavatrici nel garage di casa, con preventivi scritti a mano e
              prezzi decisi a occhio. In tre anni ho lavorato tantissimo e guadagnato poco: non mi
              mancava la competenza tecnica, mi mancava un’attività organizzata.
            </p>
            <p className="mt-4 text-[15px] leading-relaxed text-white/65 sm:text-base" data-id="element-77" data-mp="2dt2esq0v2ciu">
              Ho costruito documento per documento il sistema che oggi trovi qui dentro. Il Sistema
              Tecnico PRO 360™ è esattamente ciò che avrei voluto avere il primo giorno.
            </p>

            <ul className="mt-6 space-y-2.5" data-id="element-78" data-mp="3h3qa7ufcfnmm">
              {credentials.map(item => <li key={item} className="rounded-lg border-l-2 border-accent bg-ink-800 px-3.5 py-3 text-[14px] leading-snug text-white/75 sm:text-[15px]" data-id="element-79" data-mp="3v39ak11wxuod">
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 max-w-md" data-id="element-80" data-mp="3woice04ggpr">
              <CtaButton label="Voglio il sistema di Marco" data-id="element-81" data-mp="3tslkt00fy2w" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}